import { render, staticRenderFns } from "./GatewayFailureTransaction.vue?vue&type=template&id=c5239f5a"
import script from "./GatewayFailureTransaction.vue?vue&type=script&lang=js"
export * from "./GatewayFailureTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports